export default "__VITE_ASSET__BSVRFS28__"